import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import {
    EntityCategoryItem,
    Variant as CategoryItemVariant,
} from '@/ui-components/molecules/EntityCategoryItem/EntityCategoryItem';
import { Button, ButtonSize, ButtonVariants } from '@/ui-components/atoms/Button/Button';
import { NavDropdownContentProps } from '../../NavHeader.type';
import styles from './navDropdownSection.module.scss';

export interface NavDropdownSectionProps {
    navDropdownContent: NavDropdownContentProps;
}

export function NavDropdownSection({ navDropdownContent }: NavDropdownSectionProps) {
    const { ctaSection, itemListSection, tileSection } = navDropdownContent;
    return (
        <Grid container>
            <Grid col={{ sm: 12 }} className={styles.contentWrapper}>
                <div className={styles.ctaSection}>
                    {ctaSection?.text}
                    {ctaSection?.buttonFields?.link_text && ctaSection?.buttonFields?.href && (
                        <Button
                            variant={ctaSection?.buttonFields?.theme as ButtonVariants}
                            href={ctaSection?.buttonFields?.href}
                            type="button"
                            size={ctaSection?.buttonFields?.size?.toLocaleLowerCase() as ButtonSize}
                            className={styles.ctaButton}
                        >
                            {ctaSection?.buttonFields?.link_text}
                        </Button>
                    )}
                </div>
                <div className={styles.entityListSection}>
                    {itemListSection?.map((item, index) => (
                        <EntityCategoryItem
                            title={item.title}
                            variant={CategoryItemVariant.small}
                            items={item.images}
                            href={item.href}
                            leftAlign={false}
                            squareImage={item.squareImage}
                            isInDropdown
                            key={index}
                        />
                    ))}
                </div>
                <div className={styles.tileSection}>{tileSection}</div>
            </Grid>
        </Grid>
    );
}
